import React from 'react';
import FilterComponents from '../../product/components/FilterComponents.tsx';
import CustomDataGrid from '../../components/CustomDataGrid/CustomDataGrid.tsx';

function AddWholesellSetup(props) {
    const columns = [
        {
            field: 'checkbox',
            headerName: 'Checkbox',
            renderCell: () => <input type="checkbox" />,
        },
        { field: 'restaurantName', headerName: 'Restaurant Name', width: 200 },
        { field: 'min', headerName: 'Min', width: 200 },
        { field: 'max', headerName: 'Max', width: 200 },
        { field: 'increamentalvalue', headerName: 'Increamental Value', width: 200 },
        { field: 'isactive', headerName: 'IsActive', width: 200 }
    ];

    const dataRows = [
        { id: 1, checkbox: '', restaurantName: 'Pot Kettle Black', min: "5", max: "100", increamentalvalue: "10", isactive: 'True' },
        { id: 2, checkbox: '', restaurantName: 'Pot Kettle Black London', min: "5", max: "100", increamentalvalue: "5", isactive: 'True' }
    ];
    return (
        <div>
            <FilterComponents title={"OK"} isItem={11} />
            <CustomDataGrid columns={columns} dataRows={dataRows} />
        </div>
    );
}

export default AddWholesellSetup;